import { tools as toolEnums } from '../enums';
import EllipseLineTool from './EllipseLineTool';

const { FibToolLabelFormat } = toolEnums.FIBONACCI;

/** Fibonacci Circle tool */
export default class FibonacciCircleTool extends EllipseLineTool {
	constructor(core, settings) {
		super(core, settings);
		this.RADIUS_FACTOR = 0.707;
	}

	_getDefaultParams() {
		return {
			id: 'fibCircle',
			name: 'Fibonacci Circle',
			labelFormat: FibToolLabelFormat.DECIMAL,
			style: this.core.getStyle('tool.fibCircle')
		};
	}

	isWithin(mousePanel) {
		return this._isWithinLineTool(mousePanel);
	}

	fillEllipse(ctx, center, adjustedXDist, adjustedYDist, i) {
		const { thresholds } = this.params.style;
		ctx.save();

		if (i > 0) {
			// Don't need to clip the center-most point
			this._getDonutPath(
				ctx,
				center[0],
				center[1],
				adjustedXDist * thresholds[i],
				adjustedYDist * thresholds[i],
				adjustedXDist * thresholds[i - 1],
				adjustedYDist * thresholds[i - 1]
			);
		} else {
			this._getDonutPath(
				ctx,
				center[0],
				center[1],
				adjustedXDist * thresholds[i],
				adjustedYDist * thresholds[i]
			);
		}
		ctx.fill();

		ctx.restore();
	}

	render() {
		const coords = [this.handle[0].getCoords(), this.handle[1].getCoords()];
		if (!coords[0] || !coords[1]) return;

		const { thresholds } = this.params.style;
		const ctx = this.panel.rootToolContext;
		const upSlope = coords[0][1] > coords[1][1];
		const xDist = coords[1][0] - coords[0][0]; // x radius component
		const yDist = coords[1][1] - coords[0][1];
		const center = [coords[0][0] + xDist / 2, coords[0][1] + yDist / 2];
		const adjustedXDist = xDist * this.RADIUS_FACTOR;
		const adjustedYDist = yDist * this.RADIUS_FACTOR;

		ctx.beginPath();

		// Set default styles
		ctx.font = `${this.params.style.label.font.weight} ${this.params.style.label.font.size}px ${this.params.style.label.font.family}`;
		ctx.strokeStyle = '#CCC';
		ctx.fillStyle = '#CCC';
		ctx.lineWidth = this.params.style.width;

		thresholds.forEach((threshold, i) => {
			// Set the section line and fill colors
			ctx.strokeStyle = this.params.style.color[i];
			ctx.fillStyle = this.params.style.background.color[i];

			this.fillEllipse(
				ctx,
				center,
				adjustedXDist,
				adjustedYDist,
				i
			);

			this._getEllipsePath(
				ctx,
				center[0],
				center[1],
				adjustedXDist * threshold,
				adjustedYDist * threshold
			);
			ctx.stroke();

			ctx.textAlign = 'center';

			// Use specific label color if defined, otherwise use the section color
			ctx.fillStyle = this.params.style.label.color || this.params.style.color[i];

			if (upSlope) {
				ctx.fillText(
					this._getFibFormatValue(threshold),
					center[0],
					center[1] + adjustedYDist * threshold + 15
				);
			} else {
				ctx.fillText(
					this._getFibFormatValue(threshold),
					center[0],
					center[1] + adjustedYDist * threshold - 4
				);
			}
		});

		if (this.state.selected || this.state.hover) {
			this.handle[0].render();
			this.handle[1].render();
		}

		ctx.textAlign = 'left'; // reset the text alignment
		this._drawControlLine(ctx, coords);

		this.panel.core.onToolRender(this);
	}
}
